import { render, staticRenderFns } from "./embedPage.vue?vue&type=template&id=386d293c&scoped=true&"
import script from "./embedPage.vue?vue&type=script&lang=js&"
export * from "./embedPage.vue?vue&type=script&lang=js&"
import style0 from "./embedPage.vue?vue&type=style&index=0&id=386d293c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386d293c",
  null
  
)

export default component.exports